<template>
  <div>
    <div v-if="!loadStatus">
      <Skeleton width="100%" height="3.5rem" v-for="i in 15" :key="i" />
    </div>
    <template v-if="loadStatus">
      <div v-if="invoices.length">
        <vue-good-table
          :columns="columns"
          :rows="invoices"
          styleClass="vgt-table striped"
          style="width: 100%"
        >
          <template slot="table-row" slot-scope="invoices">
            <span v-if="invoices.column.field === 'invoiceDate'">
              <span>{{ defaultFormatAndParse(invoices.row.invoiceDate) }}</span>
            </span>
            <span v-else-if="invoices.column.field === 'amount'">
              <span>{{ invoices.row.formattedAmountDue }}</span>
            </span>
            <span v-else-if="invoices.column.field === 'status'">{{
              invoices.row.status | Capitalize
            }}</span>
            <span
              v-else-if="invoices.column.field === 'externalStripeURL'"
              class="details-btn"
            >
              <a :href="invoices.row.extenalStripeURL" target="_blank"
                >View details</a
              >
            </span>
          </template>
        </vue-good-table>
      </div>
      <div v-else>
        <InvoicesZeroState />
      </div>
    </template>
    <Pagination
      :total-items="totalRecords"
      :page="serverParams.page"
      :items-per-page="serverParams.perPage"
      @page-change="pageChange"
      @perPageChange="handlePerPageChange"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { progressStatus } from '../../helpers'
import { VueGoodTable } from 'vue-good-table'
import DateFns from '@/mixins/DateFns'
import Util from '../../mixins/Util'

export default {
  name: 'Invoices',
  mixins: [DateFns, Util],
  components: {
    VueGoodTable,
    InvoicesZeroState: () => import('@/components/Billing/InvoicesZeroState'),
    Skeleton: () => import('@/components/Universal/Skeleton'),
    Pagination: () => import('@/components/Universal/Pagination')
  },
  data() {
    return {
      columns: [
        {
          label: 'Invoice Date',
          field: 'invoiceDate',
          sortable: false,
          width: '15%'
        },
        {
          label: 'Invoice #',
          field: 'invoiceNumber',
          sortable: false,
          width: '20%'
        },
        {
          label: 'Title / Description',
          field: 'title',
          sortable: false,
          width: '30%'
        },
        {
          label: 'Amount',
          field: 'formattedAmountDue',
          sortable: false,
          width: '10%'
        },
        {
          label: 'Status',
          field: 'status',
          sortable: false,
          width: '10%'
        },
        {
          label: 'Details',
          field: 'externalStripeURL',
          sortable: false,
          width: '15%'
        }
      ],
      serverParams: {
        page: 0,
        perPage: 50
      }
    }
  },
  created() {
    this.getInvoices({
      page: 1,
      perPage: this.serverParams.perPage
    })
  },
  computed: {
    loadStatus() {
      return progressStatus(this.loadInvoices)
    },
    ...mapState({
      loadInvoices: state => state.billing.loadInvoices,
      invoices: state => state.billing.invoices,
      totalRecords: state => state.billing.invoiceCount
    })
  },
  methods: {
    ...mapActions('billing', ['getInvoices']),
    pageChange(page) {
      this.updateParams({ page: page })
      this.getNextChuckOfInvoices()
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps)
    },
    handlePerPageChange(e) {
      this.serverParams.perPage = e
      this.getNextChuckOfInvoices()
    },
    getNextChuckOfInvoices() {
      this.getInvoices({
        page: this.serverParams.page + 1,
        perPage: this.serverParams.perPage
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';

.details-btn {
  font-weight: 700;
  color: #232220;
  font-family: $inter;
}
</style>
